module.exports = __webpack_public_path__ + "static/media/Surrounding8.5c593b86.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding8.jpeg
// module id = 581
// module chunks = 0